import { faBuilding, faCheckCircle, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getLocation } from '../../actions/Locations';
import LocationService from '../../services/LocationService';

class Outlets extends Component {
  async onOutletChange(item) {
    this.props.onChangeOutlet(item);
  }

  render() {
    const outlets = this.props.geoLocation
      ? LocationService.viewableLocations(this.props.data, this.props.geoLocation)
      : this.props.data;
    return outlets.map((item) => {
      return (
        <>
          <div
            className="card flex-md-row border-bottom h-md-250 ps-3 pt-3 bg-outlet no-border cursor primary-color"
            onClick={this.onOutletChange.bind(this, item)}
          >
            <div className="row row-width">
              <div className="col-lg-12 order-types " id="order_type_id">
                <div id="order_time">
                  <div className="time-field mb-3">
                    <div className="f2 primary-font-color">
                      <span>
                        <FontAwesomeIcon icon={faBuilding} /> {item.name}
                      </span>

                      <br></br>
                      <small>
                        {item.distance && (
                          <>
                            <a href='#/' className="fw-normal primary-font-color">
                              {item.distance} KM &nbsp; <FontAwesomeIcon icon={faMapMarkerAlt} />
                            </a>
                          </>
                        )}
                        &nbsp;&nbsp;-&nbsp;&nbsp;
                        <span className="fw-normal primary-font-color">{item.formattedAddress}</span>
                      </small>
                    </div>
                    {/* {item.distance &&
                      <div className='action' style={{ paddingRight: '40px' }}>
                        <button className='btn btn-link p-0 f3-light'> {item.distance} KM &nbsp; <FontAwesomeIcon icon={faMapMarkerAlt} /></button>
                      </div>} */}
                    {item.loc_id === this.props.newSelectedOutlet.loc_id && (
                      <div className="action mt-2">
                        <button className="btn btn-link p-0 highlight-color">
                          {' '}
                          <FontAwesomeIcon icon={faCheckCircle} size={'lg'} color='var(--primary-font-color)' />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    });
  }
}
function mapStateToProps(state) {
  const { location } = state;
  return { _location: location };
}
export default connect(mapStateToProps, { getLocation })(Outlets);
